import { configureStore } from '@reduxjs/toolkit'
import UserSlice from "./User/UserSlice";
export default configureStore({
  reducer: {
    user:UserSlice,
  },
})